import { Reveal, Eyebrow } from "./Reveal";
import { HardHat, Ruler } from "lucide-react";
import { useLang } from "../i18n";

const IMG_MAIN =
  "https://images.pexels.com/photos/5584052/pexels-photo-5584052.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_SECONDARY =
  "https://images.unsplash.com/photo-1778074762022-c33cc42f79ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwaGFyZGhhdCUyMGVuZ2luZWVycyUyMGJsdWVwcmludHN8ZW58MHx8fHwxNzkyNDM5NDI3fDA&ixlib=rb-4.1.0&q=85";

export const ChiSiamo = () => {
  const { t } = useLang();
  const VALUES = [
    t("Qualità", "Quality"),
    t("Professionalità", "Professionalism"),
    t("Innovazione", "Innovation"),
    t("Trasparenza", "Transparency"),
  ];

  return (
    <section id="chi-siamo" data-testid="chi-siamo-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute inset-0 blueprint-dots opacity-[0.05] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-10 items-center">
        <div className="lg:col-span-6 relative">
          <Reveal>
            <div className="relative">
              <div className="overflow-hidden rounded-2xl border border-[#D4AF37]/25 shadow-[0_30px_80px_rgba(0,0,0,0.5)]">
                <img
                  src={IMG_MAIN}
                  alt={t(
                    "Lo studio tecnico Adriatica analizza i progetti in ufficio",
                    "The Adriatica technical studio reviewing project blueprints in the office"
                  )}
                  className="w-full h-[420px] sm:h-[520px] object-cover"
                />
              </div>
              <div className="absolute -bottom-8 -right-4 sm:-right-8 w-40 sm:w-56 overflow-hidden rounded-xl border-2 border-[#D4AF37]/40 shadow-[0_20px_60px_rgba(0,0,0,0.6)]">
                <img
                  src={IMG_SECONDARY}
                  alt={t("Tecnici Adriatica con casco e tablet in cantiere", "Adriatica technicians with hard hat and tablet on site")}
                  className="w-full h-32 sm:h-40 object-cover"
                />
              </div>
              <div className="absolute -top-5 -left-3 sm:-left-5 bg-[#0E1726] border border-[#D4AF37]/40 rounded-full px-5 py-3 flex items-center gap-2 shadow-[0_0_30px_rgba(212,175,55,0.15)]">
                <HardHat size={18} className="text-[#D4AF37]" />
                <span className="text-xs sm:text-sm font-semibold tracking-wide text-[#F3E08B]">
                  {t("Team tecnico qualificato", "Qualified technical team")}
                </span>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6">
          <Reveal>
            <Eyebrow>{t("Chi siamo", "About us")}</Eyebrow>
            <h2 className="mt-5 font-display font-semibold text-white text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
              {t("Oltre", "Over")} <span className="text-gold-gradient">{t("20 anni", "20 years")}</span>{" "}
              {t("di esperienza nel settore edile", "of construction experience")}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed">
              {t(
                "Adriatica S.r.l. Semplificata è un'azienda edile nata dalla passione per l'edilizia e dalla volontà di offrire soluzioni su misura. Operiamo con serietà, competenza e attenzione ai dettagli, per trasformare ogni progetto in realtà.",
                "Adriatica S.r.l. Semplificata is a construction company born from a passion for building and the will to offer tailor-made solutions. We work with seriousness, competence and attention to detail, turning every project into reality."
              )}
            </p>
            <p className="mt-4 text-base sm:text-lg text-slate-400 leading-relaxed">
              {t(
                "Ci avvaliamo di tecnici qualificati e professionisti di fiducia, in grado di seguire ogni fase del progetto: dal primo sopralluogo alla consegna finale.",
                "We rely on qualified technicians and trusted professionals, able to follow every phase of the project: from the first site visit to final delivery."
              )}
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 flex flex-wrap gap-3" data-testid="chi-siamo-values">
              {VALUES.map((v) => (
                <span
                  key={v}
                  className="inline-flex items-center gap-2 text-sm text-[#F3E08B] border border-[#D4AF37]/35 rounded-full px-4 py-2 bg-[#D4AF37]/5"
                >
                  <Ruler size={14} className="text-[#D4AF37]" />
                  {v}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
